var map = {
	"./brevo.png": 1420,
	"./bulksms.png": 8684,
	"./captag.png": 77135,
	"./mailersend.png": 11969,
	"./mailgun.png": 58670,
	"./mailjet.png": 22117,
	"./micleo.png": 31840,
	"./resend.png": 51574,
	"./sendgrid.png": 87109,
	"./sendinblue.png": 99012,
	"./stripe.png": 76860,
	"./supabase.png": 36137,
	"./twilio.png": 97687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37748;